// The regional MODEL TIER vocabulary the admin surfaces tag and filter by — which
// frontier model a project's agents run on, decided ONCE from the client's
// browser-detected country when the project (or the user) was first seen
// (backend/recruiter/model_tier.py, migration 0195):
//   luna   the cheaper lane: gpt-5.6-luna on every agent, PULSE rules the client low
//          intent so the concierge is never offered
//   terra  the default frontier lane
//
// Mirrors `MODEL_TIERS` in backend/recruiter/model_tier.py, which normalizes the value
// at every repo edge, so the strings here are the only ones a payload can carry.
// `unknown` is the filters' extra option and never a stored value: the column is NULL
// for every row older than the migration, and an operator asks for that bucket
// deliberately (the same rule as the device filter's `unknown`).

export const MODEL_TIERS = ["luna", "terra"] as const;

export type ModelTier = (typeof MODEL_TIERS)[number];

/** What a tier filter offers: the two real tiers plus the null bucket. */
export const MODEL_TIER_FILTER_KEYS = [...MODEL_TIERS, "unknown"] as const;

export function modelTierLabel(value: string | null): string {
  switch (value) {
    case "luna":
      return "Luna";
    case "terra":
      return "Terra";
    case "unknown":
    case null:
      return "Unknown";
    default:
      return value;
  }
}

export function isModelTier(value: unknown): value is ModelTier {
  return typeof value === "string" && (MODEL_TIERS as readonly string[]).includes(value);
}

/** The chip's hover text: what the tier MEANS, plus the country it was decided from. */
export function modelTierTitle(tier: ModelTier, country: string | null | undefined): string {
  const meaning =
    tier === "luna"
      ? "Luna lane: the cheaper model on every agent, low intent by rule (no concierge)."
      : "Terra lane: the default frontier model.";
  return country ? `${meaning} Detected country: ${country}.` : meaning;
}
